import { render, staticRenderFns } from "./MineView.vue?vue&type=template&id=1f563196"
import script from "./MineView.vue?vue&type=script&lang=js"
export * from "./MineView.vue?vue&type=script&lang=js"
import style0 from "./MineView.vue?vue&type=style&index=0&id=1f563196&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports